var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#70948d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.802 9.155a2.197 2.26 0 0 1 1.233.388A2.197 2.26 0 0 1 40 11.414v17.172a2.197 2.26 0 0 1-1.378 2.087l-22.258 9.153a2.197 2.26 0 0 1-2.048-.225 2.197 2.26 0 0 1-.964-1.874V20.556a2.197 2.26 0 0 1 1.382-2.097l22.253-9.142a2.197 2.26 0 0 1 .815-.162Zm-2.197 17.89V14.75l-17.858 7.346V34.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.198 9.155a2.197 2.26 0 0 1 1.22.38l13.35 9.152a2.197 2.26 0 0 1 .979 1.88v17.172a2.197 2.26 0 0 1-1.16 1.993 2.197 2.26 0 0 1-2.257-.113L.978 30.454A2.197 2.26 0 0 1 0 28.586V11.414a2.197 2.26 0 0 1 1.16-1.993 2.197 2.26 0 0 1 1.038-.266Zm11.154 12.62-8.957-6.138v11.729l8.957 6.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.55 22.822a2.197 2.26 0 0 1-1.22-.38L.978 13.29a2.197 2.26 0 0 1-.967-2.115 2.197 2.26 0 0 1 1.37-1.864L23.632.157a2.197 2.26 0 0 1 2.035.226L39.02 9.536a2.197 2.26 0 0 1 .966 2.115 2.197 2.26 0 0 1-1.369 1.864l-22.25 9.149a2.197 2.26 0 0 1-.818.158zM6.891 11.913l8.914 6.1 17.303-7.116-8.915-6.101z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBox);
export default __webpack_public_path__ + "static/media/marker_box.fba1a7bd9f166e67cde85818a140397e.svg";
export { ForwardRef as ReactComponent };